export default __webpack_public_path__ + "static/media/image-icon.aae4b073.svg";